import React from 'react';
import { GiftPromoSticker, GiftPromoStrip } from './GiftPromoBubble';
import { giftPromoStatus } from '../lib/giftPromo';

const THEME_EMOJIS = {
  blackfriday: '🖤', cybermonday: '💻', sale: '🏷️', flash: '⚡',
  newyear: '🎆', valentine: '💕', stpatrick: '🍀', easter: '🐰',
  summer: '☀️', backtoschool: '📚', halloween: '🎃', christmas: '🎄',
  winter: '❄️', birthday: '🎂', thankyou: '🙏', none: '', custom: ''
};

// Same date window rules the banner has always used (start inclusive, end = end of day).
export const isStoreDiscountActive = (settings) => {
  if (!settings?.store_discount_enabled || !(settings?.store_discount_percent > 0)) return false;
  const now = new Date();
  if (settings.store_discount_start_date && now < new Date(settings.store_discount_start_date)) return false;
  if (settings.store_discount_end_date) {
    const endDate = new Date(settings.store_discount_end_date);
    endDate.setHours(23, 59, 59, 999);
    if (now > endDate) return false;
  }
  return true;
};

// Store-wide sale banner (Home + Shrimp Room) with the optional free-gift sticker.
// When no sale is running but the gift promo is on, a standalone gift strip is shown instead.
export const StoreDiscountBanner = ({ settings, className = '', testId = 'store-discount-banner' }) => {
  const gift = giftPromoStatus(settings);
  if (!isStoreDiscountActive(settings)) {
    return <GiftPromoStrip gift={gift} className={className} />;
  }

  const emoji = settings.store_discount_theme === 'custom'
    ? (settings.store_discount_custom_emoji || '')
    : (THEME_EMOJIS[settings.store_discount_theme] || '🏷️');
  const bg = settings.store_discount_bg_color || '#4caf50';
  const ink = settings.store_discount_text_color || '#ffffff';

  return (
    <div
      className={`relative rounded-xl p-5 mb-6 shadow-lg text-center ${gift ? 'sm:pr-32 sm:min-h-[8.25rem] sm:flex sm:flex-col sm:justify-center' : ''} ${className}`}
      style={{ backgroundColor: bg, color: ink }}
      data-testid={testId}
    >
      <p className="text-xl md:text-2xl font-bold">
        {emoji} {(settings.store_discount_banner_text || 'SALE! {percent}% OFF all shrimp!').replace('{percent}', settings.store_discount_percent)} {emoji}
      </p>
      {settings.store_discount_end_date && (
        <p className="text-sm mt-2 opacity-90">
          Ends: {new Date(settings.store_discount_end_date).toLocaleDateString('en-IE', { weekday: 'short', month: 'short', day: 'numeric' })}
        </p>
      )}
      <GiftPromoSticker gift={gift} accent={ink} ink={bg} />
    </div>
  );
};

export default StoreDiscountBanner;
